import Icon from '../components/Icon.vue'

Icon.register({
  'compress-arrows-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M200 288c13.3 0 24 10.7 24 24v112c0 21.4-25.8 32.1-40.9 17l-31.1-33-99.3 99.3c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6l99.2-99.3-32.9-31c-15.1-15.2-4.4-41 17-41h112zM312 224c-13.3 0-24-10.7-24-24v-112c0-21.4 25.8-32.1 40.9-17l31.1 33 99.3-99.3c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6l-99.3 99.3 33 31c15.1 15.1 4.4 41-17 41h-112zM408 360l99.3 99.4c6.2 6.2 6.2 16.4 0 22.6l-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0l-99.3-99.3-31 32.9c-15.1 15.1-41 4.4-41-17v-112c0-13.3 10.7-24 24-24h112c21.4 0 32.1 25.8 17 40.9zM183 71.1c15.1-15.1 41-4.4 41 16.9v112c0 13.3-10.7 24-24 24h-112c-21.4 0-32.1-25.8-17-40.9l33-31.1-99.3-99.3c-6.2-6.2-6.2-16.4 0-22.6l25.4-25.4c6.2-6.2 16.4-6.2 22.6 0l99.3 99.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/compress-arrows-alt.js
// module id = 1233
// module chunks = 0